<template>
  <v-dialog
    v-model="display"
    width="600"
    height="500"
    persistent
  >
    <v-card>
      <v-card-title>
        <div>Costos por escala</div>
        <v-spacer></v-spacer>
        <v-btn color="primary" icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-5">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-row dense>
            <v-col cols="12 d-flex">
              <v-row dense>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="organizationIdSelected"
                    :label="'Organización'"
                    :readonly="loadingOption"
                    :items="organizationOptions"
                    item-text="name"
                    item-value="id"
                    outlined
                    filled
                    dense
                    class="mt-6"
                    @change="getData()"
                  />
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="moduleSelected"
                    :label="'Modulo'"
                    :readonly="loadingOption"
                    :items="moduleOptions"
                    item-text="text"
                    item-value="value"
                    outlined
                    filled
                    dense
                    class="mt-6"
                    @change="getData()"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="scaleSelected"
                    :label="'Límite'"
                    :readonly="loadingOption"
                    :rules="scaleRules"
                    type="number"
                    outlined
                    filled
                    dense
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="amountSelected"
                    :label="'Monto'"
                    :readonly="loadingOption"
                    :rules="amountRules"
                    type="number"
                    outlined
                    filled
                    dense
                  />
                </v-col>
              </v-row>
              <div class="d-flex align-center justify-center pl-6" style="width: 80px">
                <v-btn
                  color="primary"
                  fab
                  @click="saveOption"
                  :disabled="!valid"
                  :loading="loadingOption"
                >
                  <v-icon>
                    add
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-text class="pa-5 grey lighten-3" style="max-height: 240px; min-height: 240px; overflow-y:auto;">
        <draggable
          v-if="isEmpty"
          tag="div"
          v-model="optionsLocal"
          v-bind="dragOptions"
          @start="isDragging = true"
          @end="endDragging"
        >
          <v-card outlined v-for="(optionL, index) in optionsLocal" :key="optionL.id" tile elevation="0">
            <v-card-text class="pa-4 pl-2 pr-2 d-flex">
              <div class="cursor-move d-flex align-center justify-center" style="width: 48px">
                <v-icon>drag_indicator</v-icon>
              </div>
              <v-row dense>
                <v-col cols="6">
                  <v-text-field
                    :label="'Límite'"
                    v-model="optionL.scale"
                    type="number"
                    filled
                    outlined
                    dense
                    hide-details
                    readonly
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    :label="'Monto'"
                    v-model="optionL.amount"
                    type="number"
                    filled
                    outlined
                    dense
                    hide-details
                    readonly
                  />
                </v-col>
              </v-row>
              <div class="d-flex align-center justify-center" style="width: 48px">
                <v-btn icon @click="deleteOption(optionL.id, index)">
                  <v-icon>delete_outline</v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </draggable>
        <v-row v-else>
          <v-col cols="12" class="subtitle-2 text-center">
            <v-img
              :src="require('@/assets/svg/box_empty.svg')"
              height="150"
              max-height="150px"
              aspect-ratio="1"
              contain
            />
            <div class="grey--text subtitle-1">
              {{ $t('common.no_results_found') }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import draggable from 'vuedraggable'
import { mapState } from 'vuex'
import { AddonScalesService } from '@/services/addonScales.service'

export default {
  name: 'DialogAddonScales',
  components: {
    draggable
  },
  props: {
    display: {
      type: Boolean,
      required: true
    },
    organizationId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      organizationIdSelected: 'general',
      moduleSelected: 'emails',
      scaleSelected: null,
      amountSelected: null,
      loading: false,
      option: {
        scale: null,
        amount: null
      },
      moduleOptions: [
        { text: 'Correos', value: 'emails' },
        { text: 'Leads', value: 'leads' }
      ],
      optionsLocal: [],
      loadingOption: false,
      valid: true,
      scaleRules: [
        v => !!v || 'El campo es requerido',
        v => (v && !isNaN(v)) || 'La escala debe ser un número',
        v => (v && v > 0) || 'La escala debe ser mayor a 0',
        v => !this.optionsLocal.some(e => e.scale == v) || 'La escala ya existe'
      ],
      amountRules: [
        v => !!v || 'El campo es requerido',
        v => (v && !isNaN(v)) || 'El monto debe ser un número',
        v => (v && v > 0) || 'El monto debe ser mayor a 0'
      ]
    }
  },
  watch: {
    display (val) {
      if (val) {
        this.organizationIdSelected = this.organizationId || 'general'
        this.getData()
      }
    }
  },
  computed: {
    ...mapState({
      addons: ({ organization: { addons } }) => addons,
      organizations: ({ organization: { organizations } }) => organizations,
    }),
    organizationOptions () {
      return [
        { id: 'general', name: 'General' },
        ...this.organizations
      ]
    },
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    isEmpty () {
      if (this.optionsLocal.length > 0) {
        return true
      } else {
        return false
      }
    },
    automationAddon () {
      return this.addons.find(addon => addon.name === 'Automation')
    }
  },
  methods: {
    async endDragging (e) {
      this.updateOrder()
    },
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    async saveOption () {
      await this.validate()
      if (!this.valid) {
        return
      }
      try {
        this.loading = true
        const {
          organizationIdSelected,
          moduleSelected,
          scaleSelected,
          amountSelected
        } = this
        const data = (await AddonScalesService.store({
          organization_id: organizationIdSelected === 'general' ? null : organizationIdSelected,
          addon_id: this.automationAddon.id,
          module: moduleSelected,
          scale: scaleSelected,
          amount: amountSelected,
          order: this.optionsLocal.length + 1
        })).data
        this.optionsLocal.push(data)
        this.scaleSelected = null
        this.amountSelected = null
        this.resetValidation()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async updateOrder () {
      const orderedData = this.optionsLocal.map((option, index) => ({
        id: option.id,
        order: index + 1
      }))
      try {
        this.loading = true
        const newData = (await AddonScalesService.updateOrder({ new_order: orderedData })).data
        this.optionsLocal = newData
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async deleteOption (id, index) {
      try {
        this.loading = true
        await AddonScalesService.delete(id)
        await this.optionsLocal.splice(index, 1)
        await this.updateOrder()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    close () {
      this.cleanData()
      this.$emit('close')
    },
    cleanData () {
      this.resetValidation()
      this.optionsLocal = []
      this.organizationIdSelected = 'general'
      this.moduleSelected = 'emails'
      this.scaleSelected = null
      this.amountSelected = null
      this.loading = false
      this.loadingOption = false
    },
    async getData () {
      try {
        this.loading = true
        const { organizationIdSelected, moduleSelected } = this
        const data = (await AddonScalesService.getAll({
          organization_id: organizationIdSelected,
          module: moduleSelected,
          limit: 'all'
        })).data
        this.optionsLocal = data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
